import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlimScrollModule } from 'ng2-slimscroll';
import {SharedModule} from './../shared/shared.module';
import { FacilityRoutingModule } from './facility-routing.module';
import { FacilityDashboardComponent } from './facility-dashboard/facility-dashboard.component';
import { FacilityRuleComponent } from './facility-rule/facility-rule.component';
import { Facility } from './facility';


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FacilityRoutingModule,
    SlimScrollModule
  ],
  declarations: [FacilityRuleComponent, FacilityDashboardComponent]
})
export class FacilityModule { }


// WEBPACK FOOTER //
// ./src/app/facility/facility.module.ts